<template>
    <div class="d-flex flex-fill mt-2 mt-md-0">
        <button v-if="agotadas" class="button large-button red-content" disabled>
            {{ $t('partidos.agotadas') }}
        </button>
        <button v-else-if="ultimas_entradas" class="button large-button red-content" disabled>
            {{ $t('eventos.ultimas_entradas') }}
        </button>
        <GoToCheckoutButton
            v-else-if="comprar"
            :title="$t('partidos.comprar')"
            :subtitle="$t('partidos.soy_abonado', { abonado: teatro.texto_abonado })"
            :route="ruta"
            :event_id="event.id"
            :sesion_id="event.sesion_id"
            tipo_venta="abonados"
        />
    </div>
</template>

<script>
    import GoToCheckoutButton from "@/components/frontend/events/show/GoToCheckoutButton";

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            esLfpSga: {
                type: Boolean
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            ruta() { 
                return this.event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados'; 
            },
            comprar() {
                if (this.esLfpSga) {
                    return this.event.libres_abonados;
                }

                return this.event.libres_abonados && this.event.entradas_disponibles_abonos?.length;
            },
            agotadas() {
                if (this.esLfpSga) {
                    return (!this.event.libres_abonados && !this.event.sesiones_activas) || this.event.entradas_agotadas_online;
                }

                return (!this.event.libres_abonados && !this.event.sesiones_activas) || this.event.entradas_agotadas_online || !this.event.entradas_disponibles_abonos?.length;
            },
            ultimas_entradas() {
                return !this.event.libres_abonados && this.event.sesiones_activas;
            }
        },
        components: {
            GoToCheckoutButton
        }
    }
</script>